import { render, staticRenderFns } from "./ErrorLogo.vue?vue&type=template&id=36ebbdd7"
var script = {}
import style0 from "./ErrorLogo.vue?vue&type=style&index=0&id=36ebbdd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports